var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-title"},[_c('div',{staticClass:"back-button",on:{"click":_vm.goBack}},[_c('img',{staticClass:"back-button-icon",attrs:{"src":require("./images/back.png"),"alt":"返回"}})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }